import React, { useState } from 'react';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import banksData from '../../data/banks.json';
import appConfig from '../../utils/appConfig';
import axios from 'axios';
import { SelectChangeEvent } from '@mui/material';

interface Bank {
  id: number;
  name_he: string;
  name_en: string;
}

interface Check {
  checkDate: string;
  checkAmount: string;
  bank: string;
  branchNumber: string;
  accountNumber: string;
  checkNumber: string;
}

interface CashFormData {
  paymentType: string;
  paymentAmount: string;
  idNumber: string;
  receiptName: string;
  email: string;
}

interface CheckFormData {
  paymentType: string;
  paymentAmount: string;
  idNumber: string;
  receiptName: string;
  email: string;
  checks: Check[];
}

const CashOrCheckPay: React.FC = () => {
  const location = useLocation();
  const basicData = {
    studentId: location.state?.idNumber,
    email: location.state?.email,
    selectedStation: location.state?.selectedStation,
    serverData: location.state?.serverData,
    acceptTerms: location.state?.acceptTerms,
    grade: location.state?.grade,
    parentName: location.state?.parentName,
    phone: location.state?.phone,
    externalSchoolsForm: location.state?.externalSchoolsForm,
    amount: location.state?.externalSchoolsForm ? location.state?.amount : location.state?.amount * 2,
    Scheduling: location.state?.schedulingId,
  };
  const [paymentType, setPaymentType] = useState<string>('');
  const [, setErrors] = useState<Record<string, string>>({});
  const [isLoading, setIsLoading] = useState(false);
  const type= 'הסעה';
  const [cashFormData, setCashFormData] = useState<CashFormData>({
    paymentType: 'מזומן',
    paymentAmount: '',
    idNumber:  '',
    receiptName:  '',
    email:  '',
  });

  const [checkFormData, setCheckFormData] = useState<CheckFormData>({
    paymentType: 'המחאה',
    paymentAmount: '',
    idNumber:  '',
    receiptName:  '',
    email:  '',
    checks: [{
      checkDate: '',
      checkAmount: '',
      bank: '',
      branchNumber: '',
      accountNumber: '',
      checkNumber: '',
    }],
  });

  const banks: Bank[] = banksData;

  const { authorityName } = useParams<{ authorityName: string }>();
  const authority = appConfig.authorities.find(auth => auth.en === authorityName);

  const handleInputChange = (paymentType: 'מזומן' | 'המחאה', name: string) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { value } = event.target;

    if (name === "idNumber" && !/^\d*$/.test(value)) {
      setErrors(prevErrors => ({ ...prevErrors, [name]: 'ניתן להקיש ספרות בלבד' }));
      return;
    } else {
      setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
    }

    if (paymentType === 'מזומן') {
      setCashFormData(prevData => ({
        ...prevData,
        [name]: value
      }));
    } else if (paymentType === 'המחאה') {
      setCheckFormData(prevData => ({
        ...prevData,
        [name]: value
      }));
    }
  };

  const handleCheckChange = (index: number, field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    setCheckFormData(prevData => {
      const newChecks = prevData.checks.map((check, i) =>
        i === index ? { ...check, [field]: value } : check
      );

      const totalCheckAmount = newChecks.reduce((sum, check) => {
        return sum + parseFloat(check.checkAmount || '0');
      }, 0);

      return {
        ...prevData,
        checks: newChecks,
        paymentAmount: totalCheckAmount.toString(),
      };
    });
  };

  const handleBankChange = (index: number) => (event: SelectChangeEvent<number>) => {
    const bankId = event.target.value as number;
    const selectedBank = banks.find(bank => bank.id === bankId) || { id: 0, name_he: '' };

    setCheckFormData(prevData => {
      const newChecks = [...prevData.checks];
      newChecks[index] = {
        ...newChecks[index],
        bank : `מספר בנק: ${selectedBank.id},שם בנק: ${selectedBank.name_he}`,
      };
      return {
        ...prevData,
        checks: newChecks,
      };
    });
  };

  // const appendFormData = (data: any, formData: FormData, root: string = ''): void => {
  //   for (const key in data) {
  //     if (data.hasOwnProperty(key)) {
  //       const value = data[key];
  //       const formKey = root ? `${root}[${key}]` : key;

  //       if (typeof value === 'object' && !(value instanceof File)) {
  //         appendFormData(value, formData, formKey);
  //       } else {
  //         formData.append(formKey, value);
  //       }
  //     }
  //   }
  // };

  const navigate = useNavigate();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    setIsLoading(true);
    event.preventDefault();

    // הגדרת timeout של 10 שניות כדי להפעיל מחדש את הכפתור
    setTimeout(() => {
      setIsLoading(false);
    }, 10000);

    // הסרת גרשיים/גרש מהשנה כדי שלא ישבשו את קריאת הטקסט בקבלה
    const yearText = String(location.state?.period || appConfig.formattedYear || '').replace(/["'״׳]/g, '');

    const currentFormData: any = {
      terminal_name:authority?.tranzilaCode,
      ////document_date: '',
      //document_type: '',
      //action: 1,
      document_language: 'heb',
      document_currency_code: 'ILS',
      vat_percent: 17,
      //client_company: formData.clientCompany,
      client_address_line_1: '',

      //client_address_line_2: formData.clientAddressLine2,
      //client_zip: formData.clientZip,
      //client_city: formData.clientCity,
      ///client_country_code: 'IL',
      //items: formData.items,
      paymentType:paymentType,
      paymentAmount:paymentType==='מזומן'?cashFormData.paymentAmount:checkFormData.paymentAmount,
      type:type,
      year: yearText,
      payments: []
    };

    if (paymentType === 'מזומן') {
      currentFormData.client_id = cashFormData.idNumber;
      currentFormData.client_name =  cashFormData.receiptName;
      currentFormData.client_email =  cashFormData.email;
      
      currentFormData.payments.push({
        payment_method: 5,
        payment_date: '',
        amount: cashFormData.paymentAmount,
        currency_code: 'ILS',
        other_description: `תשלום הסעה עבור ${cashFormData.receiptName} על סך ${cashFormData.paymentAmount} שקלים`,
      });
    } else if (paymentType === 'המחאה') {
      currentFormData.client_id = checkFormData.idNumber;
      currentFormData.client_name = checkFormData.receiptName;
      currentFormData.client_email =  checkFormData.email;
      currentFormData.other_description=  `תשלום הסעה עבור ${cashFormData.receiptName} על סך ${checkFormData.paymentAmount} שקלים`;
      checkFormData.checks.forEach((check) => {
        currentFormData.payments.push({
          payment_method: 3,
          payment_date: check.checkDate,
          amount: check.checkAmount,
          currency_code: 'ILS',
          bank: check.bank,
          branchNumber:check.branchNumber,
          accountNumber:check.accountNumber,
          checkNumber:check.checkNumber,
          other_description: `בנק: ${check.bank} סניף: ${check.branchNumber} מספר חשבון: ${check.accountNumber} מספר המחאה: ${check.checkNumber}`,
        });
      });
    }

    // "עבור מה שולם" שיופיע בקבלה: הסעות - שם התלמיד, ת.ז, שנת לימודים
    currentFormData.receipt_paid_for =
      `הסעות - ${currentFormData.client_name}, ת.ז ${currentFormData.client_id}, שנת ${currentFormData.year}`;

    try {
      console.log("data to tranzila", currentFormData);
      const documentResponse = await fetch(`${appConfig.apiUrls.baseUrl}/tranzilaRoutes/createDocument`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(currentFormData),
      });

      if (documentResponse.ok) {
        const responseData = await documentResponse.json();
        console.log(responseData.data.document);

        const tranzilaDocument = responseData.data.document;
        const retrievalKey = tranzilaDocument.retrieval_key;
        // מספר הקבלה/מסמך (קצר) נשמר בזוהו; retrieval_key ארוך מדי לשדה field6 (מעל 255 תווים).
        // טרנזילה מחזירה את מספר הקבלה תחת המפתח number (למשל "32911"); document_number כחלופה.
        const documentNumber =
          tranzilaDocument.number ??
          tranzilaDocument.document_number ??
          null;
        let combinedData = {...currentFormData, ...basicData, ...responseData.data.document };

        console.log("data to hagay", combinedData);
        axios.post(appConfig.cashOrCheckPaymentUrl, combinedData)
          .then(response => {
            console.log('Data sent successfully:', response.data);
          })
          .catch(error => {
            console.error('Error sending data:', error);
          });

        // רושם "תשלום בפועל" בזוהו ומפעיל את חישוב הסכומים על השיבוץ.
        // מזומן/המחאה נחשבים "שולם" מיד עם קליטת הטופס.
        const finalizePaymentPayload: any = {
          schedulingId: basicData.Scheduling,
          typePay: paymentType,
          amount: currentFormData.paymentAmount,
          // שם המסוף (child_terminal בזוהו) - נדרש גם לזיהוי כפילויות לפי מסוף
          terminalName: currentFormData.terminal_name,
          // מספר הקבלה של טרנזילה נכנס גם לשדה המסמך (field6) וגם לשדה האסמכתא (asmahta)
          ...(documentNumber != null
            ? { docNumber: String(documentNumber), asmahta: String(documentNumber) }
            : {}),
          // retrieval_key משמש לבניית לינק הורדת המסמך בשדה link_to_doc בזוהו
          retrievalKey,
        };
        if (paymentType === 'מזומן') {
          finalizePaymentPayload.idCardHolder = cashFormData.idNumber;
          finalizePaymentPayload.notes = cashFormData.receiptName;
        } else if (paymentType === 'המחאה') {
          finalizePaymentPayload.idCardHolder = checkFormData.idNumber;
          finalizePaymentPayload.notes = checkFormData.receiptName;
          finalizePaymentPayload.checks = checkFormData.checks.map(c => ({
            checkNumber: c.checkNumber,
            checkDate: c.checkDate,
            checkAmount: c.checkAmount,
            bank: c.bank,
            branchNumber: c.branchNumber,
            accountNumber: c.accountNumber,
          }));
        }
        axios.post(`${appConfig.apiUrls.baseUrl}/zohoPayments/finalizePayment`, finalizePaymentPayload)
          .catch(error => {
            console.error('Error finalizing payment in Zoho:', error);
          });

        navigate(`/${authority?.en}/thankYouPageHokBankPay`, { state: { success: true, retrievalKey } });
      } else {
        console.error('Failed to create document');
        navigate(`/${authority?.en}/thankYouPageHokBankPay`, { state: { success: false } });
      }
    } catch (error) {
      console.error('Error sending data:', error);
      navigate(`/${authority?.en}/thankYouPageHokBankPay`, { state: { success: false } });
    }
  };


  
  

  const addNewCheck = () => {
    setCheckFormData((prevData) => {
      const firstCheck = prevData.checks[0];
      return {
        ...prevData,
        checks: [
          ...prevData.checks,
          {
            checkDate: '',
            checkAmount: '',
            bank: firstCheck.bank,
            branchNumber: firstCheck.branchNumber,
            accountNumber: firstCheck.accountNumber,
            checkNumber: firstCheck.checkNumber,
          },
        ],
      };
    });
  };
  
  
  return (
    <Box sx={{ maxWidth: 400, margin: '0 auto', padding: 2 }}>
      <Typography variant="h6" sx={{ marginBottom: 2, textAlign: 'center' }}>
        תשלום במזומן/ המחאה
      </Typography>
      <FormControl fullWidth sx={{ marginBottom: 2 }}>
        <InputLabel id="payment-type-label">סוג תשלום</InputLabel>
        <Select
          labelId="payment-type-label"
          id="payment-type-select"
          value={paymentType}
          onChange={(e) => setPaymentType(e.target.value)}
          label="סוג תשלום"
        >
          <MenuItem value="מזומן">מזומן</MenuItem>
          <MenuItem value="המחאה">המחאה</MenuItem>
        </Select>
      </FormControl>

      <form onSubmit={handleSubmit}>
        {paymentType === 'מזומן' && (
          <>
            <TextField
              fullWidth
              label="תעודת זהות"
              name="idNumber"
              value={cashFormData.idNumber}
              onChange={handleInputChange('מזומן', 'idNumber')}
              sx={{ marginBottom: 2 }}
              InputProps={{ style: { textAlign: 'right' } }}
              InputLabelProps={{ style: { textAlign: 'right', direction: 'rtl' } }}
              required
            />
            <TextField
              fullWidth
              label="שם לקבלה"
              name="receiptName"
              value={cashFormData.receiptName}
              onChange={handleInputChange('מזומן', 'receiptName')}
              sx={{ marginBottom: 2 }}
              InputProps={{ style: { textAlign: 'right' } }}
              InputLabelProps={{ style: { textAlign: 'right', direction: 'rtl' } }}
              required
            />
            <TextField
              fullWidth
              label="מייל לשליחת קבלה"
              name="email"
              type="email"
              value={cashFormData.email}
              onChange={handleInputChange('מזומן', 'email')}
              sx={{ marginBottom: 2 }}
              InputProps={{ style: { textAlign: 'right' } }}
              InputLabelProps={{ style: { textAlign: 'right', direction: 'rtl' } }}
              required
            />
            <TextField
              fullWidth
              label="סכום לתשלום"
              name="paymentAmount"
              value={cashFormData.paymentAmount}
              onChange={handleInputChange('מזומן', 'paymentAmount')}
              sx={{ marginBottom: 2 }}
              InputProps={{ style: { textAlign: 'right' } }}
              InputLabelProps={{ style: { textAlign: 'right', direction: 'rtl' } }}
              required
            />
          </>
        )}

        {paymentType === 'המחאה' && (
          <>
            <TextField
              fullWidth
              label="תעודת זהות"
              name="idNumber"
              value={checkFormData.idNumber}
              onChange={handleInputChange('המחאה', 'idNumber')}
              sx={{ marginBottom: 2 }}
              InputProps={{ style: { textAlign: 'right' } }}
              InputLabelProps={{ style: { textAlign: 'right', direction: 'rtl' } }}
              required
            />
            <TextField
              fullWidth
              label="שם לקבלה"
              name="receiptName"
              value={checkFormData.receiptName}
              onChange={handleInputChange('המחאה', 'receiptName')}
              sx={{ marginBottom: 2 }}
              InputProps={{ style: { textAlign: 'right' } }}
              InputLabelProps={{ style: { textAlign: 'right', direction: 'rtl' } }}
              required
            />
            <TextField
              fullWidth
              label="מייל לשליחת קבלה"
              name="email"
              type="email"
              value={checkFormData.email}
              onChange={handleInputChange('המחאה', 'email')}
              sx={{ marginBottom: 2 }}
              InputProps={{ style: { textAlign: 'right' } }}
              InputLabelProps={{ style: { textAlign: 'right', direction: 'rtl' } }}
              required
            />
           <div>
      {checkFormData.checks.map((check, index) => (
        <div key={index}>
          <TextField
            fullWidth
            label="תאריך ההמחאה"
            name={`checkDate-${index}`}
            type="date"
            value={check.checkDate}
            onChange={handleCheckChange(index, 'checkDate')}
            sx={{ marginBottom: 2 }}
            InputProps={{ style: { textAlign: 'right' } }}
            InputLabelProps={{ style: { textAlign: 'right', direction: 'rtl' }, shrink: true }}
            required
          />
          <TextField
            fullWidth
            label="סכום ההמחאה"
            name={`checkAmount-${index}`}
            value={check.checkAmount}
            onChange={handleCheckChange(index, 'checkAmount')}
            sx={{ marginBottom: 2 }}
            InputProps={{ style: { textAlign: 'right' } }}
            InputLabelProps={{ style: { textAlign: 'right', direction: 'rtl' } }}
            required
          />
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel id={`bank-label-${index}`}>בנק</InputLabel>
            <Select
              labelId={`bank-label-${index}`}
              id={`bank-select-${index}`}
              value={check.bank && typeof check.bank === 'string' ? parseInt(check.bank.split(':')[1].split(',')[0].trim(), 10) : ''} // Ensure check.bank is defined and is a string
              onChange={handleBankChange(index)}
              label="בנק"
              MenuProps={{
                PaperProps: {
                  sx: {
                    '& .MuiMenuItem-root': {
                      textAlign: 'right',
                    },
                  },
                },
              }}
            >
              {banks.map((bank) => (
                <MenuItem key={bank.id} value={bank.id}>
                  {bank.name_he}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            fullWidth
            label="סניף"
            name={`branchNumber-${index}`}
            value={check.branchNumber}
            onChange={handleCheckChange(index, 'branchNumber')}
            sx={{ marginBottom: 2 }}
            InputProps={{ style: { textAlign: 'right' } }}
            InputLabelProps={{ style: { textAlign: 'right', direction: 'rtl' } }}
            required
          />
          <TextField
            fullWidth
            label="מספר חשבון"
            name={`accountNumber-${index}`}
            value={check.accountNumber}
            onChange={handleCheckChange(index, 'accountNumber')}
            sx={{ marginBottom: 2 }}
            InputProps={{ style: { textAlign: 'right' } }}
            InputLabelProps={{ style: { textAlign: 'right', direction: 'rtl' } }}
            required
          />
          <TextField
            fullWidth
            label="מספר המחאה"
            name={`checkNumber-${index}`}
            value={check.checkNumber}
            onChange={handleCheckChange(index, 'checkNumber')}
            sx={{ marginBottom: 2 }}
            InputProps={{ style: { textAlign: 'right' } }}
            InputLabelProps={{ style: { textAlign: 'right', direction: 'rtl' } }}
            required
          />
        </div>
      ))}
      <Button variant="contained" onClick={addNewCheck} disabled={isLoading}  sx={{ marginBottom: 2 }}>
        הוסף המחאה
      </Button>
    </div>
          </>
        )}

        <Button type="submit" variant="contained" color="primary" fullWidth>
        {isLoading ? (
            'טוען...'
            ) : (
        'שלח'
      )}
        </Button>
      </form>
    </Box>
  );
};

export default CashOrCheckPay;

